import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cases
export const getCases = (params) => axios.get(`${API}/cases`, { params }).then(r => r.data);
export const createCase = (data) => axios.post(`${API}/cases`, data).then(r => r.data);
export const deleteCase = (id) => axios.delete(`${API}/cases/${id}`);

// News
export const getNews = (params) => axios.get(`${API}/news`, { params }).then(r => r.data);
export const createNews = (data) => axios.post(`${API}/news`, data).then(r => r.data);
export const deleteNews = (id) => axios.delete(`${API}/news/${id}`);

// Threads
export const getThreads = (params) => axios.get(`${API}/threads`, { params }).then(r => r.data);
export const createThread = (data) => axios.post(`${API}/threads`, data).then(r => r.data);
export const updateThreadStatus = (id, status) => axios.patch(`${API}/threads/${id}/status?status=${status}`);
export const getThreadMessages = (id) => axios.get(`${API}/threads/${id}/messages`).then(r => r.data);
export const createMessage = (threadId, data) => axios.post(`${API}/threads/${threadId}/messages`, data).then(r => r.data);

// Professionals
export const getProfessionals = (params) => axios.get(`${API}/professionals`, { params }).then(r => r.data);
export const createProfessional = (data) => axios.post(`${API}/professionals`, data).then(r => r.data);

// FAQs
export const getFaqs = (params) => axios.get(`${API}/faqs`, { params }).then(r => r.data);
export const createFaq = (data) => axios.post(`${API}/faqs`, data).then(r => r.data);
export const deleteFaq = (id) => axios.delete(`${API}/faqs/${id}`);

// Projects
export const getProjects = () => axios.get(`${API}/projects`).then(r => r.data);
export const getProject = (id) => axios.get(`${API}/projects/${id}`).then(r => r.data);
export const createProject = (data) => axios.post(`${API}/projects`, data).then(r => r.data);
export const updateProject = (id, data) => axios.put(`${API}/projects/${id}`, data).then(r => r.data);

// Project Search & Submission
export const searchProjects = ({ q, ...rest } = {}) => axios.get(`${API}/projects`, { params: { search: q, ...rest } }).then(r => r.data);
export const submitProject = (data) => axios.post(`${API}/projects/submissions`, data).then(r => r.data);
export const getProjectSubmissions = (status) => axios.get(`${API}/projects/submissions/all`, { params: { status } }).then(r => r.data);
export const getProjectSubmission = (id) => axios.get(`${API}/projects/submissions/${id}`).then(r => r.data);
export const approveProjectSubmission = (id) => axios.post(`${API}/projects/submissions/${id}/approve`).then(r => r.data);
export const deleteProjectSubmission = (id) => axios.delete(`${API}/projects/submissions/${id}`).then(r => r.data);
export const rejectProjectSubmission = (id, reason) => axios.post(`${API}/projects/submissions/${id}/reject`, null, { params: { reason } }).then(r => r.data);
export const joinProject = (projectId, flatNumber) => axios.post(`${API}/projects/${projectId}/join`, null, { params: { flat_number: flatNumber } }).then(r => r.data);

// Notices
export const getNotices = (params) => axios.get(`${API}/notices`, { params }).then(r => r.data);
export const createNotice = (data) => axios.post(`${API}/notices`, data).then(r => r.data);

// Leads (LMS)
export const getLeads = (params) => axios.get(`${API}/admin/leads`, { params }).then(r => r.data);
export const createLead = (data) => axios.post(`${API}/admin/leads`, data).then(r => r.data);
export const updateLeadStatus = (id, status) => axios.put(`${API}/admin/leads/${id}`, { status });
export const assignLead = (id, assignedTo) => axios.put(`${API}/admin/leads/${id}`, { assigned_to: assignedTo });

// Stats
export const getStats = () => axios.get(`${API}/admin/leads-stats`).then(r => r.data);

// Seed
export const seedData = () => axios.post(`${API}/seed`).then(r => r.data);

// Verification - Original system (admin/user document verification)
export const getPendingVerifications = () => axios.get(`${API}/admin/verification/pending`).then(r => r.data);
export const approveVerification = (id) => axios.post(`${API}/admin/verification/${id}/approve`).then(r => r.data);
export const rejectVerification = (id, notes) => axios.post(`${API}/admin/verification/${id}/reject`, null, { params: { notes } }).then(r => r.data);
export const deleteVerification = (id) => axios.delete(`${API}/admin/verification/${id}`).then(r => r.data);
export const getMyVerificationStatus = () => axios.get(`${API}/verification/my-status`).then(r => r.data);

// Buyer Verification - New system for project-specific buyer verification
export const getPendingBuyerVerifications = () => axios.get(`${API}/verification/pending`).then(r => r.data);
export const approveBuyerVerification = (verificationId, makeGroupAdmin = false) => 
  axios.post(`${API}/verification/${verificationId}/approve`, null, { params: { make_group_admin: makeGroupAdmin } }).then(r => r.data);
export const rejectBuyerVerification = (verificationId, reason) => 
  axios.post(`${API}/verification/${verificationId}/reject`, null, { params: { reason } }).then(r => r.data);
export const submitBuyerVerification = (data) => axios.post(`${API}/verification/submit`, data).then(r => r.data);
export const getBuyerVerificationStatus = (projectId) => axios.get(`${API}/verification/status/${projectId}`).then(r => r.data);
export const getProjectVerifiedBuyers = (projectId) => axios.get(`${API}/verification/project/${projectId}/verified-buyers`).then(r => r.data);

// Document Upload
export const uploadDocument = (file, documentType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('document_type', documentType);
  return axios.post(`${API}/upload/document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const submitVerificationWithDocument = (data) => {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('document_type', data.document_type);
  if (data.project_id) formData.append('project_id', data.project_id);
  if (data.flat_number) formData.append('flat_number', data.flat_number);
  if (data.notes) formData.append('notes', data.notes);
  return axios.post(`${API}/verification/submit-with-document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const getMyDocuments = () => axios.get(`${API}/documents/my`).then(r => r.data);

// Live News Aggregation
export const getLiveNews = (params) => axios.get(`${API}/news/live`, { params }).then(r => r.data);
export const refreshNewsCache = () => axios.post(`${API}/news/refresh`).then(r => r.data);

// AI-Curated Content
export const getCuratedNews = (params) => axios.get(`${API}/news/curated`, { params }).then(r => r.data);
export const getNewsCategories = () => axios.get(`${API}/news/categories`).then(r => r.data);
export const getDailyDigest = () => axios.get(`${API}/digest/daily`).then(r => r.data);
export const aiEnhanceArticle = (title, content) => axios.post(`${API}/knowledge/ai-enhance`, null, { params: { title, content } }).then(r => r.data);
export const aiAnalyzeVideo = (title, description, speakerName) => axios.post(`${API}/videos/ai-analyze`, null, { params: { title, description, speaker_name: speakerName } }).then(r => r.data);

// Push Notifications
export const getVapidKey = () => axios.get(`${API}/push/vapid-key`).then(r => r.data);
export const subscribeToPush = (subscription) => axios.post(`${API}/push/subscribe`, subscription).then(r => r.data);
export const unsubscribeFromPush = () => axios.delete(`${API}/push/unsubscribe`).then(r => r.data);
export const sendPushNotification = (payload, userIds) => axios.post(`${API}/push/send`, payload, { params: { user_ids: userIds } }).then(r => r.data);

// Notification Preferences
export const getNotificationPreferences = () => axios.get(`${API}/notifications/preferences`).then(r => r.data);
export const updateNotificationPreferences = (prefs) => axios.put(`${API}/notifications/preferences`, prefs).then(r => r.data);

// Knowledge Hub Articles
export const getKnowledgeArticles = (params) => axios.get(`${API}/knowledge`, { params }).then(r => r.data);
export const getKnowledgeArticle = (id) => axios.get(`${API}/knowledge/${id}`).then(r => r.data);
export const createKnowledgeArticle = (data) => axios.post(`${API}/knowledge`, data).then(r => r.data);
export const updateKnowledgeArticle = (id, data) => axios.put(`${API}/knowledge/${id}`, data).then(r => r.data);
export const deleteKnowledgeArticle = (id) => axios.delete(`${API}/knowledge/${id}`);

// Video Content Library
export const getVideoFilters = () => axios.get(`${API}/videos/filters`).then(r => r.data);
export const getVideos = (params) => axios.get(`${API}/videos`, { params }).then(r => r.data);
export const getVideo = (id) => axios.get(`${API}/videos/${id}`).then(r => r.data);
export const createVideo = (data) => axios.post(`${API}/videos`, data).then(r => r.data);
export const updateVideo = (id, data) => axios.put(`${API}/videos/${id}`, data).then(r => r.data);
export const deleteVideo = (id) => axios.delete(`${API}/videos/${id}`);

// Curated Educational Videos
export const getCuratedVideoCategories = () => axios.get(`${API}/curated-videos/categories`).then(r => r.data);
export const getCuratedVideos = (params) => axios.get(`${API}/curated-videos`, { params }).then(r => r.data);
export const getCuratedVideo = (id) => axios.get(`${API}/curated-videos/${id}`).then(r => r.data);
export const createCuratedVideo = (data) => axios.post(`${API}/curated-videos`, data).then(r => r.data);
export const updateCuratedVideo = (id, data) => axios.put(`${API}/curated-videos/${id}`, data).then(r => r.data);
export const deleteCuratedVideo = (id) => axios.delete(`${API}/curated-videos/${id}`);
export const seedCuratedVideos = () => axios.post(`${API}/curated-videos/seed`).then(r => r.data);

// Developer Dossier - Developer Groups
export const getDeveloperGroups = (params) => axios.get(`${API}/developer-groups`, { params }).then(r => r.data);
export const getDeveloperGroup = (id) => axios.get(`${API}/developer-groups/${id}`).then(r => r.data);
export const createDeveloperGroup = (data) => axios.post(`${API}/developer-groups`, data).then(r => r.data);
export const updateDeveloperGroup = (id, data) => axios.put(`${API}/developer-groups/${id}`, data).then(r => r.data);
export const deleteDeveloperGroup = (id) => axios.delete(`${API}/developer-groups/${id}`);
export const getDeveloperGroupProjects = (id) => axios.get(`${API}/developer-groups/${id}/projects`).then(r => r.data);

// Developer Dossier - Developer Content
export const getDeveloperContent = (params) => axios.get(`${API}/developer-content`, { params }).then(r => r.data);
export const getDeveloperContentItem = (id) => axios.get(`${API}/developer-content/${id}`).then(r => r.data);
export const createDeveloperContent = (data) => axios.post(`${API}/developer-content`, data).then(r => r.data);
export const updateDeveloperContent = (id, data) => axios.put(`${API}/developer-content/${id}`, data).then(r => r.data);
export const deleteDeveloperContent = (id) => axios.delete(`${API}/developer-content/${id}`);
export const verifyDeveloperContent = (id) => axios.put(`${API}/developer-content/${id}/verify`).then(r => r.data);

// Developer Dossier - Project Association
export const linkProjectToDeveloper = (projectId, developerGroupId) => 
  axios.put(`${API}/projects/${projectId}/developer-group`, null, { params: { developer_group_id: developerGroupId } }).then(r => r.data);
export const getProjectDeveloperDossier = (projectId) => axios.get(`${API}/projects/${projectId}/developer-dossier`).then(r => r.data);

// Developer Dossier - Seed
export const seedDeveloperDossier = () => axios.post(`${API}/developer-dossier/seed`).then(r => r.data);

// Developer Showcase - Directory
export const getDeveloperDirectory = (params) => axios.get(`${API}/developer-showcase/directory`, { params }).then(r => r.data);
export const getDeveloperProfile = (id) => axios.get(`${API}/developer-showcase/directory/${id}`).then(r => r.data);

// Developer Showcase - Featured & Leaderboard
export const getFeaturedDevelopers = (limit) => axios.get(`${API}/developer-showcase/featured`, { params: { limit } }).then(r => r.data);
export const toggleFeaturedDeveloper = (id, featured) => axios.put(`${API}/developer-showcase/featured/${id}`, null, { params: { featured } }).then(r => r.data);
export const getDeveloperLeaderboard = (params) => axios.get(`${API}/developer-showcase/leaderboard`, { params }).then(r => r.data);

// Developer Showcase - Registration
export const registerDeveloper = (data) => axios.post(`${API}/developer-showcase/register`, data).then(r => r.data);
export const getMyDeveloperRegistration = () => axios.get(`${API}/developer-showcase/my-registration`).then(r => r.data);
export const submitDDToolkitResponse = (developerId, data) => axios.post(`${API}/developer-showcase/register/${developerId}/dd-toolkit`, data).then(r => r.data);
export const approveDeveloperRegistration = (id, approved, reason) => 
  axios.put(`${API}/developer-showcase/admin/approve/${id}`, null, { params: { approved, rejection_reason: reason } }).then(r => r.data);
export const getPendingRegistrations = () => axios.get(`${API}/developer-showcase/admin/pending`).then(r => r.data);

// Developer Showcase - SPVs
export const getDeveloperSPVs = (developerId) => axios.get(`${API}/developer-showcase/spvs/${developerId}`).then(r => r.data);
export const createSPV = (parentGroupId, name, cin, type) => 
  axios.post(`${API}/developer-showcase/spvs`, null, { params: { parent_group_id: parentGroupId, name, cin, registration_type: type } }).then(r => r.data);

// Developer Showcase - Admin
export const recalculateDeveloperMetrics = () => axios.post(`${API}/developer-showcase/admin/recalculate-metrics`).then(r => r.data);

// FBC Curated Data - Permission Check
export const checkContributionPermission = (projectId) => axios.get(`${API}/fbc-curated/${projectId}/can-contribute`).then(r => r.data);

// Audit Logs
export const getAuditLogs = (projectId, limit = 50) => axios.get(`${API}/audit/logs/${projectId}`, { params: { limit } }).then(r => r.data);
